module.exports = __webpack_public_path__ + "img/xmas_snow_bg02.a91ad39d.png";